<template>
  <div v-html="text || '--empty--'" />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  options: { type: Object, required: true },
});

const text = computed(() => props.options.text.replace(/target="_blank"/g, ""));
</script>
